module.exports = __webpack_public_path__ + "static/media/briefcase.786a8d44.svg";